import React from 'react';
import Button from '../../../components/ui/Button';

const QuickActions = ({ onOrderNow, onReserveTable, onCatering }) => {
  return (
    <div className="bg-gradient-to-r from-[var(--color-primary)] to-[var(--color-brand-amber)] rounded-xl p-6 text-white">
      <h3 className="text-xl font-bold mb-2">Ready to Experience Taco Street?</h3>
      <p className="text-sm opacity-90 mb-6">
        Order online, reserve a table, or plan your next event with us
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <Button
          variant="default"
          size="default"
          iconName="ShoppingCart"
          iconPosition="left"
          onClick={onOrderNow}
          fullWidth
          className="bg-white text-[var(--color-primary)] hover:bg-white/90"
        >
          Order Now
        </Button>

        <Button
          variant="outline"
          size="default"
          iconName="Calendar"
          iconPosition="left"
          onClick={onReserveTable}
          fullWidth
          className="border-white text-white hover:bg-white/10"
        >
          Reserve Table
        </Button>

        <Button
          variant="outline"
          size="default"
          iconName="Users"
          iconPosition="left"
          onClick={onCatering}
          fullWidth
          className="border-white text-white hover:bg-white/10"
        >
          Catering
        </Button>
      </div>
    </div>
  );
};

export default QuickActions;